import { render, staticRenderFns } from "./HistoryRecord.vue?vue&type=template&id=f50964ce&scoped=true"
import script from "./HistoryRecord.vue?vue&type=script&lang=js"
export * from "./HistoryRecord.vue?vue&type=script&lang=js"
import style0 from "./HistoryRecord.vue?vue&type=style&index=0&id=f50964ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50964ce",
  null
  
)

export default component.exports